module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BreadcrumbsLayout', {
    attrs: {
      "breadcrumbs": _vm.breadcrumbsExtended,
      "bg": "grey"
    }
  }, [(_vm.hasItems) ? _c('OrganizationsList', {
    attrs: {
      "constrain-name-height": false,
      "doubler": false,
      "items": _vm.organizations,
      "title": _vm.title,
      "use-padding": false,
      "image-bg-color": _vm.imgBgColor,
      "image-bg-size": _vm.imgBgSize
    }
  }, [_c('FlexFilter', _vm._b({
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  }, 'FlexFilter', _vm.filterProps, false)), (_vm.pagesCount > 1) ? _c('OrganizationsPaginator', {
    attrs: {
      "slot": "after",
      "count": _vm.pagesCount,
      "current": _vm.page,
      "max": 6
    },
    slot: "after"
  }) : _vm._e(), _c('SelectCount', {
    attrs: {
      "slot": "right",
      "options": _vm.pageLimits,
      "value": _vm.pageLimit,
      "text": _vm.byPageText
    },
    on: {
      "change": _vm.pageLimitChange
    },
    slot: "right"
  })], 1) : _c('SiteMap', {
    attrs: {
      "title": _vm.sitemapTitle
    }
  }, [_c('FlexFilter', _vm._b({
    attrs: {
      "slot": "sidebar"
    },
    slot: "sidebar"
  }, 'FlexFilter', _vm.filterProps, false)), _vm._v(_vm._s(_vm.sitemapText))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbfb6066","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/organizations/list/component.vue
// module id = dd994732aaae3337ee82
// module chunks = 39